import { Camera, CameraResultType } from '@capacitor/camera';
import { IonAvatar, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonSpinner, IonTextarea, IonThumbnail, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { addCircleOutline, cameraOutline, chevronBackOutline, peopleOutline, personCircleOutline, refreshOutline, removeCircleOutline, trashOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

interface RouteParams {
    token: string;
}

const KidEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [uploading, setUploading] = useState<boolean>(false);
    const [Kid, setKid] = useState<any>({});
    const [kidPhoto, setKidPhoto] = useState<string>('');
    const [nameEdit, setNameEdit] = useState<boolean>(false);
    const [raceEdit, setRaceEdit] = useState<boolean>(false);
    const [genderEdit, setGenderEdit] = useState<boolean>(false);
    const [DOBEdit, setDOBEdit] = useState<boolean>(false);
    const [medicalEdit, setMedicalEdit] = useState<boolean>(false);

    const [kidRace, setKidRace] = useState<string>('');
    const [kidGender, setKidGender] = useState<string>('');
    const [kidDOB, setKidDOB] = useState<string>('');
    const [DOBDay, setDOBDay] = useState<string>('');
    const [DOBMonth, setDOBMonth] = useState<string>('');
    const [DOBMonthDays, setDOBMonthDays] = useState<any>();
    const [DOBYear, setDOBYear] = useState<any>('');
    const [DOBYears, setDOBYears] = useState<any>();
    
    const DOBMonthInputRef = useRef<any>();
    const DOBDayInputRef = useRef<any>();
    const DOBYearInputRef = useRef<any>();

    const { authKey, authenticateMember, setShowLoader, settings, monthNames, SWFullHorizLogo, SWTextDarkLogo, fadeInImage, nl2br } = useAppContext();

    const [showAlert] = useIonAlert();
    const [showToast] = useIonToast();
    const { token } = useParams<RouteParams>();
    const router = useIonRouter();

    const kidPhotoPath = '//api.besolowise.com/kids/photos/files/';  
     
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                await getKid(token, authenticated.mt);
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 2000);                 
            }
        };
        authenticate();
    }); 

    useEffect(() => {
        // Format Gender
        let gender = `${Kid.kidGender}`;
        if(gender == '' || gender == 'undefined') gender = 'Not Recorded';
        else if(gender == 'F') gender = 'Female';
        else if(gender == 'M') gender = 'Male';
        else if(gender == 'O') gender = 'Non-binary';
        else if(gender == 'U') gender = 'Not Recorded';
        setKidGender(gender);
        
       // Format DOB
       const today = new Date();
       const thisYear = today.getFullYear();
       const dob = `${Kid.kidDOB} 12:00:00`;
       const dobDate = new Date(dob);
       const dobDateStr = dobDate.toString();
       let   days = 31;
       if(dobDateStr === 'Invalid Date') {             
           setKidDOB('Not Recorded');
           setDOBDay('00');
           setDOBMonth('00');
           setDOBYear('00');
       } else {
           const dobYear = dobDate.getFullYear();
           const dobMonth = dobDate.getMonth();
           const dobCalMonth = dobMonth < 9 ? `0${dobMonth + 1}` : `${dobMonth + 1}`
           const dobMonthName = monthNames[dobMonth];
           const dobDay = dobDate.getDate();
           days = new Date(dobYear, dobMonth, 0).getDate();
           // Get age
           const yearsDiff = thisYear - dobYear;
           const monthsDiff = today.getMonth() - dobMonth;
           const daysDiff = today.getDate() - dobDay;
           let age = (monthsDiff < 0 || (monthsDiff === 0 && daysDiff < 0)) ? yearsDiff - 1 : yearsDiff;       
           const dobStr = dobMonthName + ' ' + dobDay + ', ' + dobYear + ' (' + age + ' years)'; 
           setKidDOB(dobStr);
           setDOBDay(dobDay.toString());
           setDOBMonth(dobCalMonth);
           setDOBYear(dobYear);            
       }     
       
       // Populate DOB Days options
       const daysOptions = [];
       for(let day = 1; day <= days; day++) daysOptions.push(day.toString());
       setDOBMonthDays(daysOptions);

       // Populate DOB Years options
       const start = thisYear;
       const end = thisYear - 18;
       const yearsOptions = [];
       for(let y = start; y >= end; y--) yearsOptions.push(y);
       setDOBYears(yearsOptions);       

   }, [Kid]);

   const getDaysByMonth = () => {	
       const yearSelect = DOBYearInputRef;
       const monthSelect = DOBMonthInputRef;
       const daySelect = DOBDayInputRef;
       const year = yearSelect.current.value;
       const month = monthSelect.current.value;
       const day = daySelect.current.value;
       const days = new Date(year, month, 0).getDate();
       const daysOptions = [];
       for(let d = 1; d <= days; d++) daysOptions.push(d);
       setDOBDay(day);
       setDOBMonth(month);
       setDOBMonthDays(daysOptions);
       setDOBYear(year);
   };  
   
   const toggleNameForm = () => setNameEdit(!nameEdit);
   const toggleRaceForm = () => setRaceEdit(!raceEdit);
   const toggleGenderForm = () => setGenderEdit(!genderEdit);
   const toggleDOBForm = () => setDOBEdit(!DOBEdit);
   const toggleMedicalForm = () => setMedicalEdit(!medicalEdit);
   
    const getKid = async (kt: string, mt: string) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('kt', kt);
            const response = await fetch('https://api.besolowise.com/kids/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();                
                if(typeof obj.kidID == 'number') {
                    setKid(obj); 
                    const date = new Date();
                    const time = date.getTime();
                    //setKidPhoto(kidPhotoPath + `${obj.kidPhoto}` + '?v=' + time);
                    setKidPhoto(obj.kidPhotoUrl);
                } else {
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                        position: 'middle'
                    });
                }
            } else {
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
           showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    const takePhoto = async (e: any) => {
        const target = e.target;
        try {
            const photo = await Camera.getPhoto({
                quality: 99,
                allowEditing: false,
                resultType: CameraResultType.Base64,
            });
            const img = `data:image/jpeg;base64,${photo.base64String}`;
            updateKidPhoto(img);
        } catch (error) {
            console.log('Photo cancelled');
         }
    };

    const updateKidPhoto = async (imageData: string) => {
        setUploading(true);
        const btn: any = document.getElementById('addPhoto');
        btn.setAttribute('disabled', '');
        const formName = 'photoForm';
        const formData = new FormData();
        const blob = await (await fetch(imageData)).blob();
        formData.append('token', token);
        formData.append('formName', formName);
        formData.append('kidPhoto', blob, 'temp-image.jpg');
        formData.append('mt', authKey.mt);
    
        try {
            const response = await fetch('https://api.besolowise.com/kids/update/', {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });
            
            if(response.ok) {
                const obj = await response.json();
                if(obj.success) {
                    getKid(token, authKey.mt);             
                    setUploading(false);
                    showToast({
                        message: 'Your photo was updated',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    setUploading(false);
                    showToast({
                        message: 'Data Error: Image upload failed. '+ obj.message,
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                setUploading(false);
                showToast({
                    message: 'Error: Could not connect to server.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch (error) {
            setUploading(false);
            showToast({
                message: 'Error: ' + error,
                duration: 2000,
                color: 'danger',
            });
        }
        btn.removeAttribute('disabled');
    };

    const rotatePhoto = async (e: any) => {
        const btn: any = document.getElementById('rotatePhoto');
        btn.setAttribute('disabled', '');
        const file =  `${Kid.kidPhoto}`;
        const formData = new FormData();
        formData.append('file', file);
        formData.append('mt', authKey.mt);
    
        try {            
            const response = await fetch('https://api.besolowise.com/kids/photos/rotate/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    getKid(token, authKey.mt);
                    btn.removeAttribute('disabled');
                } else {
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                    });
                    btn.removeAttribute('disabled');
                }
            } else {
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
                btn.removeAttribute('disabled');
            }
        } catch (error) {
            showToast({
              message: 'Connection Error: ' + error,
              duration: 3000,
              color: 'danger',
            });
            btn.removeAttribute('disabled');
        }
    };

    const deletePhoto = async (e: any) => {        
        const field = 'kidPhoto';
        const file =  `${Kid.kidPhoto}`;
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to DELETE this photo?',
            buttons: [
                { text: 'Cancel',
                  role: 'cancel', 
                  cssClass: 'alert-button-cancel',
                },
                {
                    text: 'Delete',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        const formData = new FormData();
                        formData.append('field', field);
                        formData.append('file', file);
                        formData.append('token', token);
                        formData.append('mt', authKey.mt);
    
                        try {
                            const response = await fetch('https://api.besolowise.com/kids/photos/delete/', {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });

                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) {
                                    getKid(token, authKey.mt);
                                    showToast({
                                        message: 'Photo was deleted.',
                                        duration: 2000,
                                        color: 'success',
                                    });
                                } else {
                                    showToast({
                                        message: 'Data Error: Photo was not deleted. Try again.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response Error: Photo was not deleted. Try again.',
                                    duration: 3000,
                                    color: 'danger',
                                    position: 'middle'
                                });
                            }
                        } catch (error) {
                            showToast({
                                message: 'Connection Error: Photo was not deleted. ' + error + ' Try again.',
                                duration: 3000,
                                color: 'danger',
                            });
                        }
                    }
                }
            ]
        })        
    };

    const updateKid = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Saving...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('formName', formName);
        formData.append('token', token);
        formData.append('mt', authKey.mt);

        try {
            const response = await fetch('https://api.besolowise.com/kids/update/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    await getKid(token, authKey.mt);
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    document.getElementById(formName + 'Cancel')?.click();
                    showToast({
                        message: 'SAVED',
                        duration: 2000,
                        color: 'success',
                    });
                } else {
                    btn.innerHTML = 'Save';
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Data Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 3000,
                    color: 'danger',
                });
            }              
        } catch(error) {
            btn.innerHTML = 'Save';
            btn.removeAttribute('disabled');
            showToast({
                message: 'Connection Error: ' + error,
                duration: 3000,
                color: 'danger',
            });
        } 
    };

    const deleteKid = () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to REMOVE this Kid?',
            buttons: [
                { text: 'Cancel',
                role: 'cancel', 
                cssClass: 'alert-button-cancel',
                },
                {
                    text: 'Remove',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('mt', authKey.mt);
                            formData.append('token', token);
                            const apiURI = 'https://api.besolowise.com/kids/delete/';
                            const response = await fetch(apiURI, {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                const obj = await response.json(); 
                                if(obj.success) router.push('/account/kids', 'back');
                                else {
                                    showToast({
                                        message: 'Data error.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Kid was not deleted',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Error deleting kid data: ' + error,
                                duration: 2000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
            await getKid(token, authKey.mt);
            event.detail.complete();
            setLoading(false);
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/kids'>Kids</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id="KidContent">
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={peopleOutline}></IonIcon> 
                                {Kid.kidFirstName} {Kid.kidLastName}
                                <br /><span>Editing a Saved Kid</span>
                            </h1>                            
                        </IonCol>
                    </IonRow>
                </IonGrid>
                                
                <IonCard>    
                    <IonCardContent>   
                        <IonLabel color={'dark'} onClick={toggleNameForm}><b>Name</b> <em className='required'>Required</em></IonLabel>                         
                        { nameEdit 
                            ? (<form name='nameForm' onSubmit={updateKid}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='kidFirstName' placeholder='First name' type='text' value={Kid.kidFirstName}></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='kidLastName' placeholder='Last name' type='text' value={Kid.kidLastName}></IonInput>
                                            </IonCol>                                   
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='nameFormCancel' onClick={toggleNameForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='nameFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : <p onClick={toggleNameForm}>{Kid.kidFirstName} {Kid.kidLastName}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleRaceForm}><b>Race or skin tone</b></IonLabel>
                        { raceEdit 
                            ? (<form name='raceForm' onSubmit={updateKid}>
                                    <IonInput className='ion-margin-top' fill='outline' name='kidRace' placeholder='Race or skin tone' type='text' value={Kid.kidRace}></IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='raceFormCancel' onClick={toggleRaceForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='raceFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleRaceForm}>{Kid.kidRace == '' ? 'Not Recorded' : Kid.kidRace}</p>)
                        }
                    </IonCardContent>
                </IonCard> 
                                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleGenderForm}><b>Gender</b></IonLabel>
                        { genderEdit 
                            ? (<form name='genderForm' onSubmit={updateKid}>
                                    <IonSelect fill='outline' labelPlacement='stacked' name='kidGender' placeholder='Gender' value={Kid.kidGender}>
                                        <IonSelectOption value='U'>I prefer not to say</IonSelectOption>
                                        <IonSelectOption value='F'>Female</IonSelectOption>
                                        <IonSelectOption value='M'>Male</IonSelectOption>
                                        <IonSelectOption value='O'>Non-binary</IonSelectOption>
                                    </IonSelect>
                                    <IonButton className='ion-margin-top' color={'medium'} id='genderFormCancel' onClick={toggleGenderForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='genderFormSubmit' type='submit'>Save</IonButton>
                                </form>)
                            : <p onClick={toggleGenderForm}>{kidGender}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleDOBForm}><b>Date of Birth</b></IonLabel>
                        { DOBEdit 
                            ? (<form name='DOBForm' onSubmit={updateKid}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6' sizeSm='4'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='kidDOBMonth' onIonChange={getDaysByMonth} placeholder='Month' ref={DOBMonthInputRef} value={DOBMonth}>                                     
                                                    <IonSelectOption value='00'>Month</IonSelectOption>
                                                    {monthNames.map((name:string, index:number) => (
                                                        <IonSelectOption key={index} value={index < 9 ? `0${index + 1}` : `${index + 1}`}>{name}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                            <IonCol size='6' sizeSm='4'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='kidDOBDay' onIonChange={getDaysByMonth} placeholder='Day' ref={DOBDayInputRef} value={DOBDay}>                                     
                                                    <IonSelectOption value='00'>Day</IonSelectOption>
                                                    {DOBMonthDays.map((day:string, index:number) => (
                                                        <IonSelectOption key={index} value={index < 9 ? `0${index + 1}` : `${index + 1}`}>{day}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                            <IonCol size='12' sizeSm='4'>
                                                <IonSelect fill='outline' labelPlacement='stacked' name='kidDOBYear' onIonChange={getDaysByMonth} placeholder='Year' ref={DOBYearInputRef} value={DOBYear}>                                     
                                                    <IonSelectOption value='0000'>Year</IonSelectOption>
                                                    {DOBYears.map((year:string, index:number) => (
                                                        <IonSelectOption key={index} value={year}>{year}</IonSelectOption>
                                                    ))}
                                                </IonSelect>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='DOBFormCancel' onClick={toggleDOBForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='DOBFormSubmit' type='submit'>Save</IonButton>                                
                                </form>)                                                     
                            : <p onClick={toggleDOBForm}>{kidDOB}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleMedicalForm}><b>Medical or Other Important Info</b></IonLabel>
                        { medicalEdit 
                            ? (<form name='medicalForm' onSubmit={updateKid}>
                                    <IonTextarea className='ion-margin-top' fill='outline' name='kidMedical' placeholder='Medical or Other Important Info' value={Kid.kidMedical}></IonTextarea>
                                    <p>This is not considered to be an official medical record. Please remember, others will see this if you don't check-in by your scheduled time.</p>
                                    <IonButton className='ion-margin-top' color={'medium'} id='medicalFormCancel' onClick={toggleMedicalForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='medicalFormSubmit' type='submit'>Save</IonButton>
                                </form>)
                            : <p onClick={toggleMedicalForm}>{Kid.kidMedical == '' ? 'Not Recorded' : (<span dangerouslySetInnerHTML={{ __html: nl2br(Kid.kidMedical) }} />)}</p>
                        }
                    </IonCardContent>
                </IonCard>
                
                <IonCard className='ion-text-center'>
                    <IonCardContent>
                        <IonLabel color={'dark'}><b>Photo</b></IonLabel>   
                        <p className='ion-margin-top'>Photos must be .jpg format.</p>                     
                        <IonThumbnail>
                            {uploading
                                ? (<div className='no-user-photo'><IonSpinner name="crescent"></IonSpinner></div>)
                                : (Kid.kidPhoto == ''
                                    ? (<div className='no-user-photo' onClick={takePhoto}><IonIcon icon={personCircleOutline}></IonIcon></div>)  
                                    : (<IonImg src={kidPhoto} onIonImgDidLoad={fadeInImage} />)
                                )
                            } 
                        </IonThumbnail>                                
                        {Kid.kidPhoto == ''
                            ? (<IonButton className='ion-margin' color={'tertiary'} id='addPhoto' onClick={takePhoto}><IonIcon slot="start" icon={addCircleOutline}></IonIcon> Add Photo</IonButton>)
                            : (<>
                                <IonButton className='ion-margin' color={'tertiary'} fill='outline' id='rotatePhoto' onClick={rotatePhoto} shape="round" size='default'><IonIcon icon={refreshOutline} slot='start'></IonIcon> Rotate</IonButton>
                                <IonButton className='ion-margin' color={'remove'} fill='outline' id='deletePhoto' onClick={deletePhoto} shape="round" size='default'><IonIcon icon={trashOutline} slot='start'></IonIcon> Delete</IonButton>
                                </>) 
                        } 
                    </IonCardContent>
                </IonCard>

                <div className='ion-text-center'>
                    <IonButton className='ion-margin delete-button-outline' color={'remove'} fill="outline" onClick={deleteKid}><IonIcon icon={trashOutline} slot='start'></IonIcon> Remove Kid</IonButton>
                </div>

            </IonContent>
        </IonPage>
    );
};

export default KidEdit;
